const hostRouter = [{
    path: '/overview',
    component: () => import('@/pages/Index'),
    redirect: {
      name: 'overview'
    },
    children: [{
      name: 'overview',
      path: 'index',
      component: () => import('@/pages/overview/OverView'),
    }]
  },
]
export default hostRouter



// WEBPACK FOOTER //
// ./src/router/modules/host.js